<div class="cx-scope cx-ledger">
  <div class="cx-toolbar">
    <button type="button" class="cx-btn cx-btn--ghost cx-btn--icon" (click)="close()" aria-label="Close">
      <cx-icon name="x" class="cx-icon--lg"></cx-icon>
    </button>
    <span class="cx-toolbar-title">{{ title }}</span>
    <span class="cx-toolbar-note">Read only · from MedicAI Connect</span>
    <span class="cx-toolbar-actions">
      <button *ngIf="data.clinicalPatientId" type="button" class="cx-btn cx-btn--outline cx-btn--auto" (click)="openPatientFile()">
        <cx-icon name="user"></cx-icon> Patient file
      </button>
    </span>
  </div>

  <div class="cx-ledger-scroll">
    <ng-container *ngIf="ledger as l">
      <!-- Money header -->
      <div class="cx-money-cards">
        <div class="cx-money-card">
          <div class="cx-money-label">Scheme owes</div>
          <div class="cx-money-value">{{ rand(l.header.schemeOwedCents) }}</div>
        </div>
        <div class="cx-money-card">
          <div class="cx-money-label">Patient owes</div>
          <div class="cx-money-value">{{ rand(l.header.patientOwedCents) }}</div>
        </div>
        <div class="cx-money-card" *ngIf="l.header.aging.creditCents > 0">
          <div class="cx-money-label">Credit available</div>
          <div class="cx-money-value">{{ rand(l.header.aging.creditCents) }}</div>
        </div>
        <div class="cx-money-card">
          <div class="cx-money-label">Account aging<span class="cx-money-label-note">scheme + patient</span></div>
          <div class="cx-aging-grid">
            <div><span>Current</span><strong>{{ rand(l.header.aging.current) }}</strong></div>
            <div><span>30 days</span><strong>{{ rand(l.header.aging.d30) }}</strong></div>
            <div><span>60 days</span><strong>{{ rand(l.header.aging.d60) }}</strong></div>
            <div><span>90+ days</span><strong>{{ rand(l.header.aging.d90 + l.header.aging.d120plus) }}</strong></div>
          </div>
        </div>
      </div>

      <!-- Tabs -->
      <div role="tablist" aria-label="Ledger views" class="cx-tabs">
        <button *ngFor="let tab of tabs" type="button" role="tab" [attr.aria-selected]="activeTab === tab.id"
          class="cx-tab" [class.cx-tab--active]="activeTab === tab.id" (click)="activeTab = tab.id">
          <cx-icon [name]="tab.icon" class="cx-icon--lg"></cx-icon>
          {{ tab.label }}
        </button>
      </div>

      <!-- History -->
      <div role="tabpanel" *ngIf="activeTab === 'activity'">
        <div class="cx-empty-state" *ngIf="!l.activity.length">
          <span class="cx-empty-state-icon"><cx-icon name="activity" class="cx-icon--lg"></cx-icon></span>
          <p>No account activity yet</p>
        </div>
        <div class="cx-table-wrap" *ngIf="l.activity.length">
          <table class="cx-table">
            <thead>
              <tr><th></th><th class="cx-nowrap">Date</th><th class="cx-wide">What happened</th><th class="cx-num">Scheme owes</th><th class="cx-num">Patient owes</th></tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let ev of l.activity">
                <tr class="cx-clickable" (click)="toggleEntry(ev)">
                  <td><cx-icon [name]="entryDrill(ev).expanded ? 'chevron-down' : 'chevron-right'" class="cx-icon--chevron"></cx-icon></td>
                  <td class="cx-nowrap">{{ ev.timestamp | date: 'd MMM yyyy, HH:mm' }}</td>
                  <td class="cx-wide">
                    <span [class]="'cx-group-pill cx-group-pill--' + groupOf(ev.sourceType)">{{ ev.label }}</span>
                    <button *ngIf="ev.documentId" type="button" class="cx-link" (click)="openDocument(ev.documentId); $event.stopPropagation()">Open claim</button>
                    <span class="cx-effect">{{ effectText(ev.schemeMovementCents, ev.patientMovementCents, !!ev.writtenOff) }}</span>
                  </td>
                  <td class="cx-num">{{ rand(ev.schemeBalanceCents) }}</td>
                  <td class="cx-num">{{ rand(ev.patientBalanceCents) }}</td>
                </tr>
                <tr class="cx-drill-row" *ngIf="entryDrill(ev).expanded">
                  <td colspan="5" class="cx-drill-cell">
                    <div class="cx-drill-title">Ledger postings</div>
                    <div class="cx-drill-vat" *ngIf="ev.vatCents !== null">net {{ rand(ev.netCents) }} · VAT {{ rand(ev.vatCents) }}</div>
                    <div class="cx-drill-loading" *ngIf="entryDrill(ev).loading"><cx-icon name="loader"></cx-icon> Loading postings…</div>
                    <p class="cx-drill-error" *ngIf="entryDrill(ev).error">{{ entryDrill(ev).error }}</p>
                    <table class="cx-table" *ngIf="!entryDrill(ev).loading && entryDrill(ev).rows?.length">
                      <thead><tr><th class="cx-wide">Account</th><th class="cx-num cx-w32">Debit</th><th class="cx-num cx-w32">Credit</th></tr></thead>
                      <tbody>
                        <tr *ngFor="let p of entryDrill(ev).rows">
                          <td class="cx-wide">{{ p.account.name }}</td>
                          <td class="cx-num">{{ p.debitCents ? rand(p.debitCents) : '' }}</td>
                          <td class="cx-num">{{ p.creditCents ? rand(p.creditCents) : '' }}</td>
                        </tr>
                      </tbody>
                    </table>
                    <p class="cx-drill-none" *ngIf="!entryDrill(ev).loading && !entryDrill(ev).error && entryDrill(ev).rows && !entryDrill(ev).rows?.length">No postings recorded for this entry.</p>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Claims & invoices -->
      <div role="tabpanel" *ngIf="activeTab === 'documents'">
        <div class="cx-empty-state" *ngIf="!l.documents.length">
          <span class="cx-empty-state-icon"><cx-icon name="file-text" class="cx-icon--lg"></cx-icon></span>
          <p>No billing documents for this patient yet</p>
        </div>
        <div class="cx-docs" *ngIf="l.documents.length">
          <div class="cx-doc" *ngFor="let doc of l.documents; trackBy: trackDoc" [attr.data-doc]="doc.id">
            <div class="cx-doc-head">
              <button type="button" class="cx-doc-toggle" [attr.aria-expanded]="isDocOpen(doc.id)" (click)="toggleDoc(doc.id)">
                <cx-icon name="chevron-right" class="cx-doc-chevron" [class.cx-doc-chevron--open]="isDocOpen(doc.id)"></cx-icon>
                <span class="cx-doc-date">{{ (doc.serviceDate || doc.createdAt) | date: 'd MMM yyyy' }}</span>
                <span class="cx-doc-kind">{{ kind(doc.type) }}</span>
                <span class="cx-doc-tracking" *ngIf="doc.trackingId">{{ doc.trackingId }}</span>
                <span [class]="'cx-doc-status cx-pill-' + statusTone(docStatus(doc))">{{ docStatus(doc) }}</span>
                <span class="cx-doc-right">
                  <span class="cx-doc-story">
                    <ng-container *ngFor="let part of story(doc); let last = last">
                      {{ part.label }} <span class="cx-doc-story-value">{{ rand(part.cents) }}</span><ng-container *ngIf="!last"> · </ng-container>
                    </ng-container>
                  </span>
                  <span [class]="'cx-doc-settlement cx-pill-' + settlementTone(doc.settlement.status)">{{ settlementLabel(doc.settlement.status) }}</span>
                </span>
              </button>
            </div>

            <div class="cx-doc-body" *ngIf="isDocOpen(doc.id)">
              <div class="cx-doc-ident" *ngIf="doc.hnetNumber || doc.trackingId">
                <span *ngIf="doc.hnetNumber"><span class="cx-doc-ident-label">MediKredit ref</span><span class="cx-doc-ident-value">{{ doc.hnetNumber }}</span></span>
                <span *ngIf="doc.trackingId"><span class="cx-doc-ident-label">Claim ref</span><span class="cx-doc-ident-value">{{ doc.trackingId }}</span></span>
              </div>

              <div class="cx-table-wrap">
                <table class="cx-table cx-table--lines">
                  <thead>
                    <tr><th></th><th>Code</th><th class="cx-wide">Description</th><th class="cx-num">Billed</th><th class="cx-num">Scheme approved</th><th class="cx-num">Not covered</th><th class="cx-num">Patient pays</th><th class="cx-num">Paid</th><th>Status</th></tr>
                  </thead>
                  <tbody>
                    <ng-container *ngFor="let line of doc.lines">
                      <tr class="cx-clickable" (click)="toggleLine(line)">
                        <td><cx-icon [name]="lineDrill(line).expanded ? 'chevron-down' : 'chevron-right'" class="cx-icon--chevron"></cx-icon></td>
                        <td>{{ line.tariffCode }}</td>
                        <td class="cx-wide cx-break">{{ line.description }}</td>
                        <td class="cx-num">{{ rand(line.billedCents) }}</td>
                        <td class="cx-num">{{ rand(line.approvedCents) }}</td>
                        <td class="cx-num">{{ rand(line.rejectedCents) }}</td>
                        <td class="cx-num">{{ rand(line.patientLiableCents) }}</td>
                        <td class="cx-num">{{ rand(line.paidCents) }}</td>
                        <td>{{ line.status || '—' }}</td>
                      </tr>
                      <tr class="cx-drill-row" *ngIf="lineDrill(line).expanded">
                        <td colspan="9" class="cx-drill-cell">
                          <div class="cx-reasons" *ngIf="line.reasonCodes?.length">
                            <span class="cx-reason" *ngFor="let rc of line.reasonCodes">{{ rc.code }}{{ rc.description ? ' — ' + rc.description : '' }}</span>
                          </div>
                          <div class="cx-drill-loading" *ngIf="lineDrill(line).loading"><cx-icon name="loader"></cx-icon> Loading transactions…</div>
                          <p class="cx-drill-error" *ngIf="lineDrill(line).error">{{ lineDrill(line).error }}</p>
                          <table class="cx-table" *ngIf="!lineDrill(line).loading && lineDrill(line).rows?.length">
                            <thead><tr><th class="cx-nowrap">Date</th><th class="cx-nowrap">What happened</th><th class="cx-wide">Ledger account</th><th class="cx-num cx-w32">Debit</th><th class="cx-num cx-w32">Credit</th></tr></thead>
                            <tbody>
                              <tr *ngFor="let tx of lineDrill(line).rows">
                                <td class="cx-nowrap">{{ tx.timestamp | date: 'd MMM yyyy, HH:mm' }}</td>
                                <td class="cx-nowrap">{{ tx.label }}</td>
                                <td class="cx-wide">{{ tx.account.name }}</td>
                                <td class="cx-num">{{ tx.debitCents ? rand(tx.debitCents) : '' }}</td>
                                <td class="cx-num">{{ tx.creditCents ? rand(tx.creditCents) : '' }}</td>
                              </tr>
                            </tbody>
                          </table>
                          <p class="cx-drill-none" *ngIf="!lineDrill(line).loading && !lineDrill(line).error && lineDrill(line).rows && !lineDrill(line).rows?.length">No ledger transactions attributed to this line yet.</p>
                        </td>
                      </tr>
                    </ng-container>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <div class="cx-skeleton-list cx-skeleton-list--rows" role="status" aria-live="polite" *ngIf="loading && !ledger">
      <span class="cx-sr-only">Loading…</span>
      <div class="cx-skeleton-card" aria-hidden="true" *ngFor="let row of [1, 2, 3, 4]">
        <div class="cx-skeleton cx-skeleton--a"></div>
        <div class="cx-skeleton cx-skeleton--b"></div>
      </div>
    </div>

    <div class="cx-problem" role="alert" *ngIf="error">
      <cx-icon name="circle-alert" class="cx-problem-icon"></cx-icon>
      <div class="cx-problem-text">
        <p class="cx-problem-heading">The ledger did not load</p>
        <p class="cx-problem-message">{{ error }}</p>
      </div>
      <button type="button" class="cx-btn cx-btn--outline cx-btn--default-size" (click)="load()">Try again</button>
    </div>
  </div>
</div>
